import "./Services.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ServiceCategories from "./sections/ServiceCategories";
import ServingTheAustinMetroArea from "./sections/ServingTheAustinMetroArea";
import ContactTeaser from "./sections/ContactTeaser";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <NavigationHeader />
      <Hero />
      <ServiceCategories />
      <ServingTheAustinMetroArea />
      <ContactTeaser />
      <Footer />
    </div>;
}